(function Processor($, Adzuki)
{
	"use strict";

	var processor_content = null;
	var processor_actions = null;

	$(document).ready(function documentReady()
	{
		Adzuki.onload('CruiseBooking/processor', function onload() {
			processor_content = $('div.processor-content');
			processor_actions = cleanupProcessorActions(
				$.parseJSON($('#processor-actions').val())
			);

			processNextAction();

			// $('.econnect-loader').dblclick(function swapLoader() {
			// 	$(this).attr('src', Adzuki.base_uri + '/adzuki/images/econnect-loader-homer.gif');
			// });
		}, false);
	});

	function processNextAction()
	{
		var load_action     = processor_content.data('load-action');
		var complete_action = processor_content.data('complete-action');
		var force_complete  = processor_content.data('force-complete');

		Adzuki.Ajax.get('/CruiseBooking/' + load_action + '/' + force_complete + '/' + Math.random())
		.then(function success(data) {
			if (data['return_value'] === 'complete') {
				if (
					typeof data['post_manual_payment'] !== 'undefined'
					&& data['post_manual_payment'] === true
				) {
					// post a manual payment after retrieving the booking
					window.location.href = Adzuki.base_uri + '/Reservations/postPayment/' + data['reservation_vendor_id'];
				} else {
					window.location.href = Adzuki.base_uri + '/CruiseBooking/' + complete_action;
				}
			}

			if (data['return_value'] === 'exception') {
				window.location.href = Adzuki.base_uri + data['redirect_url'];
			}

			if (data['return_value'] === 'continue') {
				updateActionsDataAttrs(load_action, complete_action);
				processNextAction();
			}
		});
	}

	function updateActionsDataAttrs(current_load_action, current_complete_action)
	{
		var current_step        = parseInt(processor_actions[current_load_action].step);
		var current_step_circle = $('div.econnect-booking-item.econnect-booking-active');
		var current_step_line   = current_step_circle.prev();
		var next_step_line      = current_step_circle.next();
		var next_step_circle    = next_step_line.next();
		var next_action         = null;

		current_step++;

		// figure out the next step action
		$.each(processor_actions, function onEachProcessorAction(index, action) {
			if (parseInt(action.step) === current_step) {
				next_action = action;
				return false;
			}
		});

		// update data attrs to the next action
		processor_content.data('load-action', next_action.load_action);
		processor_content.data('complete-action', next_action.complete_action);

		// update classes on the steps
		current_step_circle.removeClass('econnect-booking-active')
						   .addClass('econnect-booking-complete');
		current_step_line.removeClass('econnect-booking-incomplete')
						 .addClass('econnect-booking-complete');
		next_step_circle.removeClass('econnect-booking-incomplete')
						.addClass('econnect-booking-active');
		next_step_line.removeClass('econnect-booking-incomplete')
					  .addClass('econnect-booking-active');

	}

	/**
	 * Remove actions for retrieval, cruise sheet, quick quote, comparison,
	 * packages and special services since we ain't gonna need it
	 * in the processor_actions Object.
	 *
	 * @param  {Object} processor_actions
	 * @return {Object}
	 */
	function cleanupProcessorActions(processor_actions)
	{
		$.each(processor_actions, function onEachProcessorAction(index, action) {
			if (
				action.type === 'retrieval' ||
				index.indexOf('CruiseSheet') >= 0 ||
				index.indexOf('QuickQuote') >= 0 ||
				index.indexOf('Comparison') >= 0 ||
				index.indexOf('Packages') >= 0 ||
				index.indexOf('SpecialServices') >= 0
			) {
				delete processor_actions[index];
			}
		});

		return processor_actions;
	}

}(jQuery, window.Adzuki || {}));
